module.exports = __webpack_public_path__ + "static/media/BrianSu.e6cd983b.png";